<script>
	export let onReload;
	export let onRegist;
	export let onRegistServer;
</script>

<div class="d-flex p-2">
	<div class="ms-auto">
		<div class="input-group justify-content-end">
			<button class="btn btn-sm btn-outline-primary" on:click={onReload}>Reload</button>
			<button class="btn btn-sm btn-primary" on:click={onRegist}>신규등록</button>
			<button class="btn btn-sm btn-outline-primary" on:click={onRegistServer}>서버적용</button>
		</div>
	</div>
</div>
